import {
  Container,
  Divider,
  Grid,
  GridItem,
  useDisclosure,
  useColorModeValue,
  Flex,
} from '@chakra-ui/react';
import Breadcrumbs from '../../common/Breadcrumbs';
import ApiKeysList from '../../components/client/api-docs/ApiKeysList';
import ViewApiDocs from '../../components/client/api-docs/ViewApiDocs';
import CreateApiKeyModal from '../../components/modals/CreateApiKeyModal';
import { KeysListContextProvider } from '../../store/client/KeysListContext';
import ApiKeysIconAnimated from '../../theme/illustrations-animated/ApiKeysIconAnimated';
import ApiKeysIconDarkAnimated from '../../theme/illustrations-animated/ApiKeysIconDarkAnimated';
import ApiKeyListHeader from '../../components/client/api-docs/ApiKeyListHeader';
import WebhooksContainer from '../../components/client/api-docs/WebhooksContainer';
import WebhooksTableWrapper from '../../components/client/api-docs/WebhooksTableWrapper';
import useOrganizationStatus from '../../hooks/useOrganisationStatus';
import { MeContext } from '../../context/MeContext';
import { useContext } from 'react';
import { ROLES } from '../../constants/roles';

const DeveloperToolsPage = () => {
  const {
    state: { account },
  } = useContext(MeContext);

  const {
    isOpen: isCreateApiKeyOpen,
    onOpen: onCreateApiKeyOpen,
    onClose: onCreateApiKeyClose,
  } = useDisclosure();

  const modeKeysIcon = useColorModeValue(
    <ApiKeysIconAnimated />,
    <ApiKeysIconDarkAnimated />
  );
  const { shouldRender, components } = useOrganizationStatus(modeKeysIcon);

  const breadcrumbLinks = [
    {
      linkName: 'Home',
      linkUrl: '/',
    },
    {
      linkName: 'developer tools',
      linkUrl: '/developer-tools',
    },
  ];

  return (
    <>
      <KeysListContextProvider>
        <Container display="flex" flexDir="column" flex="1" pb={6}>
          <Breadcrumbs breadcrumbLinks={breadcrumbLinks} />
          <ApiKeyListHeader onCreateApiKeyOpen={onCreateApiKeyOpen} />
          <Divider borderColor="primaryBackground" mb={6} />
          {components}
          {shouldRender && (
            <Grid
              templateColumns={{
                base: '1fr',
                xl: '2fr 1fr',
                '2xl': '2.5fr 1fr',
              }}
              gap={6}
              mt={6}
            >
              <GridItem w="full">
                <Flex direction="column" gap={6}>
                  <ApiKeysList />
                  <WebhooksTableWrapper />
                </Flex>
              </GridItem>
              <GridItem w="full" placeSelf="flex-start">
                <ViewApiDocs />
              </GridItem>
            </Grid>
          )}
        </Container>
        <CreateApiKeyModal
          isOpen={isCreateApiKeyOpen}
          onClose={onCreateApiKeyClose}
        />
      </KeysListContextProvider>
    </>
  );
};
export default DeveloperToolsPage;
